import React from 'react';
import { ArrowUpRightIcon, LockIcon, RadioIcon } from 'lucide-react';
import { useIsLive } from '../hooks/useIsLive';
type LiveAccessButtonProps = {
  href: string;
  startsAt: string;
  availability: string;
};
export function LiveAccessButton({
  href,
  startsAt,
  availability
}: LiveAccessButtonProps) {
  const isLive = useIsLive(startsAt);
  if (isLive) {
    return <a href={href} target="_blank" rel="noopener noreferrer" className="group flex h-full flex-col justify-between gap-6 rounded-2xl border-2 border-ink bg-white p-5 text-ink transition-[transform,background-color] duration-150 ease-out hover:-translate-y-0.5 hover:bg-[#fafafa] focus:outline-none focus-visible:ring-4 focus-visible:ring-cnt-cyan/60 active:translate-y-0 sm:p-6" data-id="element-9" data-mp="2n7km36b1z3mo">
        <div className="flex items-start justify-between" data-id="element-10" data-mp="12rzjf2te0g2y">
          <span className="flex h-11 w-11 items-center justify-center rounded-full bg-cnt-cyan text-white" data-id="element-11" data-mp="12pd0k711qe5f">
            <RadioIcon className="h-5 w-5" aria-hidden="true" data-id="element-12" data-mp="3ire4okcegsul" />
          </span>
          <ArrowUpRightIcon className="h-6 w-6 text-ink/60 transition-transform duration-150 ease-out group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-ink" aria-hidden="true" data-id="element-13" data-mp="3ip9ph691w7f0" />
        </div>
        <div className="text-left" data-id="element-14" data-mp="3dri0ajzsizei">
          <span className="block whitespace-nowrap text-xl font-semibold tracking-tight sm:text-2xl" data-id="element-15" data-mp="3dqgb7blxwcds">
            Accéder au live
          </span>
          <span className="mt-2 inline-flex items-center gap-2 rounded-full bg-cnt-red/10 px-3 py-1 text-sm font-medium text-[#b3202f]" data-id="element-16" data-mp="33tv8iwxe7dd4">
            <span className="relative flex h-2 w-2" aria-hidden="true" data-id="element-17" data-mp="2q400c16dgv0g">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-cnt-red opacity-60 motion-reduce:hidden" data-id="element-18" data-mp="2v109wm2fkfwb" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-cnt-red" data-id="element-19" data-mp="2g5avpa3hl725" />
            </span>
            En direct sur YouTube
          </span>
        </div>
      </a>;
  }
  return <button type="button" disabled aria-disabled="true" aria-describedby="live-availability" className="flex h-full w-full cursor-not-allowed flex-col justify-between gap-6 rounded-2xl border-2 border-dashed border-black/15 bg-white/50 p-5 text-left text-ink sm:p-6" data-id="element-20" data-mp="220k2gizvxx9g">
      <div className="flex w-full items-start justify-between" data-id="element-21" data-mp="1nbxke9ivirej">
        <span className="flex h-11 w-11 items-center justify-center rounded-full bg-black/[0.06] text-muted" data-id="element-22" data-mp="2kwtmdmxgxi1d">
          <RadioIcon className="h-5 w-5" aria-hidden="true" data-id="element-23" data-mp="2g03895584wil" />
        </span>
        <LockIcon className="h-5 w-5 text-muted" aria-hidden="true" data-id="element-24" data-mp="2az5nckstxode" />
      </div>
      <div data-id="element-25" data-mp="260ugmixtztze">
        <span className="block whitespace-nowrap text-xl font-semibold tracking-tight text-ink/45 sm:text-2xl" data-id="element-26" data-mp="2613y1i4t8sth">
          Accéder au live
        </span>
        <span id="live-availability" className="mt-2 inline-flex items-center gap-2 rounded-full bg-cnt-yellow/20 px-3 py-1 text-sm font-medium text-[#8a5a00]" data-id="element-27" data-mp="zltfzzxv2nmh">
          <span className="h-1.5 w-1.5 rounded-full bg-cnt-yellow" aria-hidden="true" data-id="element-28" data-mp="36alr57ni3jz8" />
          {availability}
        </span>
      </div>
    </button>;
}